import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            font-size: .7rem;
            font-weight: 400;
            margin: 0;
            padding: 2px 5px;
            border-left: 4px solid;
        }
    }

    .legend-item {
        margin-top: 0;
        margin-bottom: 5px;
        position: relative;

        &:before {
            font-family: 'icone-gc';
            color: inherit;
            position: absolute;
        }

        &.legend-item-gray {
            color: #585858;
            background-color: #eeeeee;
            border-color: #585858;
        }

        &.legend-item-dark-blue {
            color: #00252b;
            background-color: #ccdadd;
            border-color: #00252b;
        }

        &.legend-item-orange {
            color: #ff832b;
            background-color: rgba(255, 131, 43, 0.2);
            border-color: #ff832b;
        }

        &.legend-item-green {
            color: #2ca000;
            background-color: rgba(43, 160, 0, 0.2);
            border-color: #2ca000;
        }
    }
`

export default function Legend(props){
	const {
	} = props

	return (
		<Wrapper className="card border-none bg-white text-gc-dark-blue p-3">
            <div className="legend">
                    <ul>
                        <li className="legend-item legend-item-gray">{'pending'.trad()}</li>
                        <li className="legend-item legend-item-dark-blue">{'opened'.trad()}</li>
                        <li className="legend-item legend-item-orange">{'underoption'.trad()}</li>
                        <li className="legend-item legend-item-green">{'booked'.trad()}</li>
                    </ul>
                </div>
		</Wrapper>
	);
}